var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-box",class:{ active: _vm.isChecked, reverse: _vm.isReverse, bgwhite: _vm.isBgWhite },on:{"click":function($event){$event.stopPropagation();return _vm.handleCheckBoxClick.apply(null, arguments)}}},[_c('i',{staticClass:"far fa-check"})])
}
var staticRenderFns = []

export { render, staticRenderFns }